export default __webpack_public_path__ + "static/media/location-pink.e56e77b4.svg";